import React, { useState, useEffect } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  InputLabel,
  Grid,
  IconButton,
  Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

const MonthYearsPicker = ({ onChange }) => {
  const currentDate = new Date();
  // const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed
  const currentYear = currentDate.getFullYear();

  const [month, setMonth] = useState(null);
  const [year, setYear] = useState(null);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const years = Array.from({ length: 3 }, (_, i) => currentYear - i);

  useEffect(() => {
    if (onChange) {
      onChange({ month, year }); // customTable3 ka props hai---CustomTable3 components.
    }
  }, []); // Only on initial render

  const handleMonthChange = (event) => {
    const selectedMonth = event.target.value;
    setMonth(selectedMonth);
    if (onChange) {
      onChange({ month: selectedMonth, year });
    }
  };

  const handleYearChange = (event) => {
    const selectedYear = event.target.value;
    setYear(selectedYear);
    if (onChange) {
      onChange({ month, year: selectedYear });
    }
  };

  const handleRefresh = () => {
    setMonth("");
    setYear("");
    if (onChange) {
      onChange({ month: "", year: "" });
    }
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item lg={5} md={5} xs={12}>
        <FormControl fullWidth>
          <InputLabel id="month-label">Month</InputLabel>
          <Select
            labelId="month-label"
            value={month}
            onChange={handleMonthChange}
          >
            {months.map((monthName, index) => (
              <MenuItem key={index} value={index + 1}>
                {monthName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item lg={5} md={5} xs={8}>
        <FormControl fullWidth>
          <InputLabel id="year-label">Year</InputLabel>
          <Select labelId="year-label" value={year} onChange={handleYearChange}>
            {years.map((yearValue) => (
              <MenuItem key={yearValue} value={yearValue}>
                {yearValue}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Grid item lg={1} md={1} xs={2}>
        <Tooltip title="Refresh">
          <IconButton onClick={handleRefresh} aria-label="refresh">
            <RefreshIcon />
          </IconButton>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

export default MonthYearsPicker;

// import React, { useState, useEffect } from "react";
// import {
//   FormControl,
//   MenuItem,
//   Select,
//   InputLabel,
//   Grid,
//   TextField,
// } from "@mui/material";

// const MonthYearsPicker = ({ onChange }) => {
//   const currentDate = new Date();
//   // const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed
//   const currentYear = currentDate.getFullYear();

//   const [month, setMonth] = useState(null); // Default to current month
//   const [year, setYear] = useState(null); // Default to current year
//   // const [partnerUserName, setPartnerUser] = useState(null);

//   const months = [
//     "January",
//     "February",
//     "March",
//     "April",
//     "May",
//     "June",
//     "July",
//     "August",
//     "September",
//     "October",
//     "November",
//     "December",
//   ];

//   const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years

//   useEffect(() => {
//     // Notify parent about the default selection on initial render only
//     if (onChange) {
//       onChange({
//         month,
//         year,
//         // partner_username: partnerUserName,
//       });
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []); // Empty dependency array ensures this runs only once on mount

//   const handleMonthChange = (event) => {
//     setMonth(event.target.value);
//     if (onChange) {
//       onChange({ month: event.target.value, year });
//     }
//   };

//   const handleYearChange = (event) => {
//     setYear(event.target.value);
//     if (onChange) {
//       onChange({ month, year: event.target.value });
//     }
//   };
//   // const partnerUserChange = (event) => {
//   //   setPartnerUser(event.target.value);
//   //   if (onChange) {
//   //     onChange({ month, year, partner_username: event.target.value });
//   //   }
//   // };

//   return (
//     <Grid container spacing={2}>
//       {/* partner User Name */}
//       {/* <Grid item lg={4} md={4} xs={4}>
//         <TextField
//           //   size="small"
//           label="Name"
//           type="text"
//           value={partnerUserName}
//           onChange={partnerUserChange}
//           //   InputLabelProps={{ shrink: true }}
//           variant="outlined"
//         />
//       </Grid> */}
//       {/* Month Dropdown */}
//       <Grid item lg={4} md={4} xs={4}>
//         <FormControl fullWidth>
//           <InputLabel id="month-label">Month</InputLabel>
//           <Select
//             labelId="month-label"
//             value={month}
//             onChange={handleMonthChange}
//           >
//             {months.map((monthName, index) => (
//               <MenuItem key={index} value={index + 1}>
//                 {monthName}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>

//       {/* Year Dropdown */}
//       <Grid item lg={4} md={4} xs={4}>
//         <FormControl fullWidth>
//           <InputLabel id="year-label">Year</InputLabel>
//           <Select labelId="year-label" value={year} onChange={handleYearChange}>
//             {years.map((yearValue) => (
//               <MenuItem key={yearValue} value={yearValue}>
//                 {yearValue}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
//     </Grid>
//   );
// };

// export default MonthYearsPicker;

// import React, { useState, useEffect } from "react";
// import { FormControl, MenuItem, Select, InputLabel, Grid } from "@mui/material";

// const MonthYearPicker = ({ onChange }) => {
//   const currentDate = new Date();
//   const currentMonth = currentDate.getMonth() + 1; // Months are 0-indexed
//   const currentYear = currentDate.getFullYear();

//   const [month, setMonth] = useState(currentMonth); // Default to current month
//   const [year, setYear] = useState(currentYear);   // Default to current year

//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December",
//   ];

//   const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years

//   useEffect(() => {
//     // Notify parent about the default selection
//     if (onChange) {
//       onChange({ month: currentMonth, year: currentYear });
//     }
//   }, [onChange, currentMonth, currentYear]);

//   const handleMonthChange = (event) => {
//     setMonth(event.target.value);
//     if (onChange) {
//       onChange({ month: event.target.value, year });
//     }
//   };

//   const handleYearChange = (event) => {
//     setYear(event.target.value);
//     if (onChange) {
//       onChange({ month, year: event.target.value });
//     }
//   };

//   return (
//     <Grid container spacing={2}>
//       {/* Month Dropdown */}
//       <Grid item lg={6} md={6} xs={6}>
//         <FormControl fullWidth>
//           <InputLabel id="month-label">Month</InputLabel>
//           <Select
//             labelId="month-label"
//             value={month}
//             onChange={handleMonthChange}
//           >
//             {months.map((monthName, index) => (
//               <MenuItem key={index} value={index + 1}>
//                 {monthName}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>

//       {/* Year Dropdown */}
//       <Grid item lg={6} md={6} xs={6}>
//         <FormControl fullWidth>
//           <InputLabel id="year-label">Year</InputLabel>
//           <Select
//             labelId="year-label"
//             value={year}
//             onChange={handleYearChange}
//           >
//             {years.map((yearValue) => (
//               <MenuItem key={yearValue} value={yearValue}>
//                 {yearValue}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
//     </Grid>
//   );
// };

// export default MonthYearPicker;

// import React, { useState } from "react";
// import { FormControl, MenuItem, Select, InputLabel, Grid } from "@mui/material";

// const MonthYearPicker = ({ onChange }) => {
//   const [month, setMonth] = useState("");
//   const [year, setYear] = useState("");

//   const months = [
//     "January", "February", "March", "April", "May", "June",
//     "July", "August", "September", "October", "November", "December",
//   ];

//   const currentYear = new Date().getFullYear();
// //   console.log("currentYear: ", currentYear);
//   const years = Array.from({ length: 10 }, (_, i) => currentYear - i); // Last 10 years
// //   console.log("years: ", years);

//   const handleMonthChange = (event) => {
//     setMonth(event.target.value);
//     onChange && onChange({ month: event.target.value, year });
//   };

//   const handleYearChange = (event) => {
//     setYear(event.target.value);
//     onChange && onChange({ month, year: event.target.value });
//   };

//   return (
//     <Grid container spacing={2}>
//       {/* Month Dropdown */}
//       <Grid item lg={6} md={6} xs={6}>
//         <FormControl fullWidth>
//           <InputLabel id="month-label">Month</InputLabel>
//           <Select
//           label="Month"
//             labelId="month-label"
//             value={month}
//             onChange={handleMonthChange}
//           >
//             {months.map((monthName, index) => (
//                  <MenuItem key={index} value={index + 1}>
//             {/* //   <MenuItem key={index} value={monthName}> */}
//                 {monthName}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>

//       {/* Year Dropdown */}
//       <Grid item lg=
//       {6}  md={6} xs={6}>
//         <FormControl fullWidth>
//           <InputLabel id="year-label">Year</InputLabel>
//           <Select
//             labelId="year-label"
//             value={year}
//             onChange={handleYearChange}
//           >
//             {years.map((yearValue) => (
//               <MenuItem key={yearValue} value={yearValue}>
//                 {yearValue}
//               </MenuItem>
//             ))}
//           </Select>
//         </FormControl>
//       </Grid>
//     </Grid>
//   );
// };

// export default MonthYearPicker;
